require('./index.scss')

import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import DigitalLicenseDialog from '@/components/DigitalLicenseDialog'
import { translate } from '@/utils/translations'

import icon from './digital-purchase-icon.svg'

const DigitalPurchase = ({ duration, bookshelfAccessDuration }) => (
  <div className='digital-purchase'>
    <img alt="" src={icon} />
    <span className='digital-purchase__text font-5'>
      <Choose>
        <When condition={duration === 'perpetual'}>
          <FormattedMessage id="digital_license.lifetime_license" />
        </When>
        <Otherwise>
          {translate(
            "digital_license.rental_license",
            { duration: bookshelfAccessDuration }
          )}
        </Otherwise>
      </Choose>
      <DigitalLicenseDialog />
    </span>
  </div>
)

DigitalPurchase.propTypes = {
  bookshelfAccessDuration: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired
}

export default DigitalPurchase
